import { render, staticRenderFns } from "./POI.vue?vue&type=template&id=3a026d02&scoped=true&"
import script from "./POI.vue?vue&type=script&lang=js&"
export * from "./POI.vue?vue&type=script&lang=js&"
import style0 from "./POI.vue?vue&type=style&index=0&id=3a026d02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a026d02",
  null
  
)

export default component.exports